import { apiUrl } from 'src/config'

export {
  AUTH_ENDPOINTS,
  SUBPROCESSOR_ENDPOINTS,
  SHARE_ENDPOINTS,
  API_ERRORS,
  ANALYTICS_EVENTS,
  ERROR_TYPES,
}

const AUTH_ENDPOINTS = {
  LOGIN: apiUrl + '/login',
}

const SUBPROCESSOR_ENDPOINTS = {
  GET_LIST: apiUrl + '/get_subprocessor_list',
}

// Grant share POST (`share.service.js`). Path aligns with authenticated API origin.
const SHARE_ENDPOINTS = {
  SHARE: apiUrl + '/share',
}

const API_ERRORS = {
  UNAUTHORIZED: 'Unauthorized',
  REQ_ERROR: 'API Request Error',
  NETWORK_ERROR: 'Network Error',
  CORS_ERROR: 'CORS Error',
}

const ANALYTICS_EVENTS = {
  MAP_VIEW: 'Map View',
}

// Used for both [bracket prefix] in error_name AND error_type (Error.name in PostHog)
const ERROR_TYPES = {
  API: 'API Request Error',
  AUTH: 'Authentication Error',
  VUE: 'Vue Error',
  QUERY: 'Query Error',
  MUTATION: 'Mutation Error',
  UNCAUGHT: 'Uncaught Error',
  VERSION_MISMATCH: 'Version Mismatch Error',
  OFFLINE: 'Offline Error',
}
